import React from 'react'

export const BudgetBazaarbox = () => {
    return (
        <div  style={{ display: "flex",marginTop:"3px" }}>
            <div>
                <img src="https://cdn.shopclues.com/images/banners/Diet&Nutrition_ColorGold_3rdJune_PR.jpg" alt="" />
            </div>
            <div>
                <img src="https://cdn.shopclues.com/images/banners/goldbanner_Beauty_3rdJune_PR.jpg" alt="" />

            </div>
            <div>
                <img src="https://cdn.shopclues.com/images/banners/goldbanner_WaterBottles_3rdJune_PR.jpg" alt="" />
            </div>
        </div>
    )
}
